import formurlencoded from 'form-urlencoded';

export default function processTrack(payload) {
  return function(dispatch) {
    dispatch({
      type: 'TRACK_PROCESSING_START',
      payload: payload
    });

    return new Promise((resolve, reject) => {
      fetch(REST_URL + 'tracks/process', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formurlencoded(payload)
      }).then(response => response.json())
      .then(json => {
          dispatch({
            type: 'TRACK_PROCESSING_COMPLETE',
            payload: json
          });
          resolve();
        },
        () => reject()
      )
    });
  }
};
